<template>
  <div class="blank-text-completion-component-container">
    <div
      v-for="(group, index) in groups"
      :key="index"
      class="group"
    >
      <div class="group-heading">
        {{ groupHeading(index) }}
      </div>
      <template v-for="answer in group">
        <input
          :id="`answer-${answer.id}`"
          :key="`input-${answer.id}`"
          v-model="selected"
          :disabled="answered"
          :value="answer.id"
          type="checkbox"
        >
        <label
          :key="`label-${answer.id}`"
          :for="`answer-${answer.id}`"
          :class="{ selected: selected.includes(answer.id), answered: answered, correct: answered && answer.correct }"
        >
          <div class="fill" />
          <div class="text">
            <div
              class="answer-text"
              v-html="answer.content"
            />
          </div>
        </label>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    answered: {
      type: Boolean,
    },
    answerIds: {
      type: Array,
    },
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    flashcardState: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    answers() {
      let answers = this.flashcard.answers;
      return answers.sort((a, b) => a.sortOrder - b.sortOrder);
    },
    groups() {
      return this.answers.reduce((groups, answer, index) => {
        groups[Math.floor(index / this.flashcard.blankTextColumns)].push(answer);
        return groups;
      }, Array.from({length: this.rows}, () => []));
    },
    rows() {
      return Math.floor(this.answers.length / this.flashcard.blankTextColumns);
    },
    selected: {
      get() {
        if(this.flashcardState.answerIds) {
          return this.flashcardState.answerIds;
        }
        return this.answerIds;
      },
      set(newIds) {
        const oldIds = this.answerIds;
        // if a new id was checked
        if (newIds.length > oldIds.length) {
          // find new id
          const newId = newIds.find(id => !oldIds.includes(id));
          // find column it is in
          const group = this.groups.find(g => g.map(a => a.id).includes(newId));
          // remove any ids that are in same column
          newIds = newIds.filter(id => id === newId || !group.map(a => a.id).includes(id));
        }
        this.$emit('set-answer-ids', newIds);
      },
    },
  },
  methods: {
    groupHeading(index) {
      return `Blank (${'i'.repeat(index + 1)})`;
    },
  },
};
</script>

<style lang='scss' scoped>
  .blank-text-completion-component-container {
    display: flex;
    padding-top: rem-calc(32);

    @include breakpoint(small) {
      flex-direction: column;
    }

    .group {
      flex: 1;
      margin-bottom: rem-calc(32);

      .group-heading {
        font-size: rem-calc(18);
        margin-bottom: rem-calc(16);
      }
    }

    input {
      display: none;

      + label {
        display: flex;
        padding: rem-calc(8) 0;

        &:not(.answered) {
          cursor: pointer;
        }

        .fill {
          background: $white-1;
          background-size: contain !important;
          border: 1px solid $blue-3;
          border-radius: 100%;
          box-sizing: border-box;
          height: 16px;
          margin: rem-calc(2) 0;
          width: 16px;

          @include breakpoint(small) {
            height: 14px;
            width: 14px;
          }
        }

        &.selected:not(.answered) {
          .fill {
            background: $white-1;
            border: 1px solid $blue-3;
            position: relative;

            &:after {
              background-color: $blue-3;
              border-radius: 50%;
              content: "";
              display: block;
              font-size: 1px;
              height: 10px;
              left: 2px;
              line-height: 1px;
              position: absolute;
              top: 2px;
              width: 10px;

              @include breakpoint(small) {
                height: 8px;
                width: 8px;
              }
            };
          }

          .text {
            font-weight: $semi-bold;
          }
        }

        &.answered {
          &.selected:not(.correct) .fill {
            @include incorrect-svg(#FA726F);
            background-color: white;
            border: none;
          }

          &.correct .fill {
            @include correct-svg(#70CF63);
            background-color: white;
            border: none;
          }
        }

        &.selected .answer-text {
          font-weight: $semi-bold;
        }

        .text {
          color: #354052;
          flex: 1;
          font-size: rem-calc(13);
          line-height: rem-calc(21);
          margin: 0 rem-calc(8);

          .answer-text {
            /deep/ p {
              margin: 0;
            }

            /deep/ img {
              box-sizing: border-box;
              max-height: rem-calc(560);
              padding: rem-calc(8);
            }
          }
        }
      }
    }
  }
</style>
